import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './components/states/store';
import "./components/css/index.css"
import Loader from './components/common/loader';


const App = lazy(() => import("./pages/App") )

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <Suspense fallback={<Loader/>} >
        <App />
    </Suspense>
  </Provider>
);